<template>
  <div class="scroll-box w100p">
    <div class="tagsGroup">
      <a-tabs
        size="small"
        v-model:activeKey="activeIndex"
        hideAdd
        @tabClick="tabClick"
        type="editable-card"
        @edit="removeTag"
      >
        <a-tab-pane
          v-for="(item, index) in store.state.user.routerTags"
          :key="index"
        >
          <template #tab>
            <a-dropdown :trigger="['contextmenu']">
              <span :data-path="item.menuPath" :data-systemid="item.systemId">
                {{
                  i18n.global.locale != 'zh-CN' && item.menuNameEn
                    ? item.menuNameEn
                    : item.menuName
                }}
              </span>
              <template #overlay>
                <a-menu @click="k => rightClick(k, index)">
                  <a-menu-item :key="1">关闭右侧</a-menu-item>
                  <a-menu-item :key="2">关闭其他</a-menu-item>
                  <a-menu-item :key="3">全部关闭</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, toRefs, watch, inject } from 'vue'
import { useStore } from 'vuex'
import { CloseOutlined } from '@ant-design/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const searchValue = inject('searchValue')
    const state = reactive({
      activeIndex: store.state.user.routerTags.length - 1
    })
    watch(
      [() => route.fullPath],
      () => {
        const path =
          route.fullPath.indexOf('http') > -1
            ? route.query.target
            : route.fullPath

        state.activeIndex = store.state.user.routerTags.findIndex(item => {
          return item.menuPath === path
        })
      },
      {
        immediate: true
      }
    )
    watch(
      () => store.state.user.routerTags,
      (newVal, oldVal) => {
        let path = ''
        // 新增一个
        if (newVal.length - oldVal.length === 1) {
          state.activeIndex = newVal.length - 1
          path = newVal[newVal.length - 1].menuPath
          if (path.startsWith('http')) {
            store.commit(
              'app/SET_OTHER_SYSTEM',
              {
                id: newVal[state.activeIndex].systemId,
                name: newVal[state.activeIndex].systemName,
                menuName: newVal[state.activeIndex].menuName
              },
              {
                root: true
              }
            )
            router.push({
              name: 'Iframe',
              query: {
                target: path
              }
            })
          } else {
            router.push(path)
          }
          // searchValue.value = path
        } else if (newVal.length === oldVal.length) {
          let idx = -1
          for (let len = oldVal.length, i = len - 1; i >= 0; i--) {
            if (oldVal[i].menuPath !== newVal[i].menuPath) {
              idx = i
              break
            }
          }
          if (idx > -1) {
            state.activeIndex = idx
            path = newVal[idx].menuPath
            if (path.startsWith('http')) {
              console.log(newVal[idx].systemName)
              store.commit(
                'app/SET_OTHER_SYSTEM',
                {
                  id: newVal[idx].systemId,
                  name: newVal[idx].systemName,
                  menuName: newVal[idx].menuName
                },
                {
                  root: true
                }
              )

              router.push({
                name: 'Iframe',
                query: {
                  target: path
                }
              })
            } else {
              router.push(path)
            }
          }
          // searchValue.value = path
        }
      }
    )

    /**
     * 删除标签
     */
    const removeTag = index => {
      store.commit(
        'user/saveHistoryRouter',
        {
          index
        },
        {
          root: true
        }
      )
      if (index === state.activeIndex) {
        if (state.activeIndex > 0) {
          openWindow(index - 1)
        } else if (store.state.user.routerTags.length) {
          openWindow(index)
        } else {
          router.push('/')
        }
      } else if (index < state.activeIndex) {
        state.activeIndex--
      }
    }
    const tabClick = index => {
      openWindow(index)
    }
    /**
     * 判断当前的tag是否为最后一个
     * @param {*} index
     */
    const isLastTag = index => {
      const routerTags = store.state.user.routerTags
      const tagLen = routerTags.length
      return index === tagLen - 1
    }
    const rightClick = ({ key }, tabIndex) => {
      const routerTags = cloneDeep(store.state.user.routerTags)
      const tagLen = routerTags.length
      let newTags = []
      for (let index = 0; index < tagLen; index++) {
        if (
          (key === 1 && index > tabIndex) ||
          (key === 2 && tabIndex !== index) ||
          key === 3
        ) {
          const deleteItem = routerTags[index]
          document.getElementById(deleteItem.menuPath) &&
            document.getElementById(deleteItem.menuPath).remove()
        } else {
          newTags.push(routerTags[index])
        }
      }
      store.commit('user/updateTags', newTags, {
        root: true
      })
      if (key === 1 || key === 2) {
        openWindow(newTags.length - 1)
      }
      if (newTags.length === 0) {
        router.push('/')
      }
    }
    /**
     * 添加浏览记录
     */
    const openWindow = index => {
      const item = store.state.user.routerTags[index]
      store.commit(
        'app/SET_OTHER_SYSTEM',
        {
          id: +item.systemId,
          name: item.systemName,
          menuName: item.menuName
        },
        {
          root: true
        }
      )
      state.activeIndex = index
      const path = item.menuPath
      if (path !== Location.href) {
        if (path.startsWith('http')) {
          router.push({
            name: 'Iframe',
            query: {
              target: path
            }
          })
        } else {
          router.push({
            path
          })
        }
      }
      searchValue.value = item.menuName
    }
    const initBreadTags = () => {
      const result = store.state.user.menuList.find(item => {
        return item.menuPath === (route.query.target || route.path)
      })
      store.commit(
        'user/saveHistoryRouter',
        {
          data: result
        },
        {
          root: true
        }
      )
    }
    onMounted(() => {
      initBreadTags()
    })
    return {
      removeTag,
      openWindow,
      tabClick,
      rightClick,
      store,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.tagsGroup {
  color: #b2b2bb !important;
  white-space: nowrap;
  height: 35px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  :deep .ant-tabs-bar {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
.tagsGroup {
  background: #fff;
  padding-left: 0;
}
.tagsGroup .ant-tag {
  color: #b2b2bb;
  border: 1px solid #ccc;
  padding: 2px 3px;
  border-radius: 5px;
  display: inline-block;
  margin: 0 5px;
  line-height: normal;
  cursor: pointer;
  background: transparent;
  font-size: 12px;
  &.active {
    color: #333;
    .anticon-close {
      color: #333;
      margin-left: 3px;
    }
  }
}
</style>
